import CanvasWM from './CanvasWM'
import { userInfo } from '@/store/app-common-data/userInfo.js'
import { applicationSettings } from '@/store/app-common-data/applicationSetting'
import CookieOperation from '@/plugins/cookie'

export default {
  methods: {
    async getCurrentUserName () {
      let userName = ''
      await this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
        userName = res.data.name
      })
      return userName
    },
    async getWaterMark (waterMark) {
      let waterMarkEnable = applicationSettings.waterMarkEnable
      // 首次可能为空
      if (waterMarkEnable === '') {
        let domain = document.domain
        if (domain === 'localhost') {
          domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '8854.rc-dev-test.ywsoftware.cn'
        }
        let params = { 'domain': domain }
        /** 注意：平台这边和开发者中心不同，平台无法访问开发者中心的服务，应用设置会在另一个接口返回 */
        await this.$axios.get('/system-api/application/getSettingByDomain', { params }).then(res => {
          if (res.data.data) {
            waterMarkEnable = res.data.data.waterMarkEnable
          }
        })
      }
      if (waterMarkEnable === true) {
        let currentUserName = userInfo.name
        if (!currentUserName) {
          currentUserName = await this.getCurrentUserName()
        }
        let wm = new CanvasWM({container: waterMark.container, content: currentUserName, zIndex: waterMark.zIndex})
        wm.createWM()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/public/waterMark/waterMarkMixin.js